"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = require("../Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    tab: function tab(_ref2) {
      var border = _ref2.border;
      return {
        marginTop: spacing(3),
        width: '100%',
        paddingTop: 1,
        paddingBottom: 1,
        border: border ? "".concat((0, _ramda.propOr)(1, 'width', border), "px solid ").concat(border.color ? palette[border.color] : palette.primary.main) : 'none'
      };
    },
    tabHeader: {
      height: 24,
      cursor: 'pointer'
    },
    descriptionTitle: {
      fontSize: 20,
      fontWeight: 'bold',
      color: palette.text.primary
    }
  };
});

var CloseableTab = function CloseableTab(_ref3) {
  var _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? '' : _ref3$name,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      children = _ref3.children,
      icon = _ref3.icon,
      isOpen = _ref3.isOpen,
      border = _ref3.border,
      toggleOpen = _ref3.toggleOpen;
  var classes = useStyles({
    border: border
  });
  var tabIcon = isOpen ? 'angle-up' : 'angle-down';
  var handleToggleTab = (0, _react.useCallback)(function () {
    return toggleOpen(name, isOpen);
  }, [name, isOpen, toggleOpen]);
  return /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    elevation: 1,
    className: classes.tab
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.tabHeader,
    m: 3,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    onClick: handleToggleTab
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.descriptionTitle
  }, title), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: icon || tabIcon
  })), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": isOpen,
    unmountOnExit: true,
    addEndListener: undefined
  }, children));
};

var _default = /*#__PURE__*/(0, _react.memo)(CloseableTab);

exports["default"] = _default;